import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "../pages/index";
import NotFound from "../pages/404";
import axios from "axios";
import Loader from "../components/loader";

const AppRoutes = () => {
  const [isValid, setValid] = useState(true);
  const checkXevoraAPI = async () => {
    let res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api//verify/xevora-api`
    );
    if (res.status == 200 && res?.data?.valid == true) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  useEffect(() => {
    checkXevoraAPI();
  }, []);

  if (!isValid) {
    return (
      <React.Suspense fallback={<Loader />}>
        <Routes>
          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
